import {gql} from 'apollo-angular';

export const GET_COMPANY_PROFILE_QUIZ_QUESTIONS = gql`
  query GetCompanyProfileQuizQuestions {
    getCompanyProfileQuizQuestions {
      id
      question
      correctAnswer
      wrongAnswer1
      wrongAnswer2
      wrongAnswer3
      questionNumber
    }
  }
`;
